/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StationFollowersList } from '../../models/station-followers-list';
import { UidsBody } from '../../models/uids-body';

export interface SearchStationsFollowers$Params {
      body: UidsBody
}

export function searchStationsFollowers(http: HttpClient, rootUrl: string, params: SearchStationsFollowers$Params, context?: HttpContext): Observable<StrictHttpResponse<StationFollowersList>> {
  const rb = new RequestBuilder(rootUrl, searchStationsFollowers.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationFollowersList>;
    })
  );
}

searchStationsFollowers.PATH = '/stations/followers/search';
